import { useState, useEffect, useCallback } from 'react'
import { mockMarkets, generatePriceUpdate } from '../data/mockMarkets'

// Custom hook to manage market data with simulated live updates
export const useMarkets = (updateInterval = 3000) => {
  const [markets, setMarkets] = useState(mockMarkets)
  const [isLoading, setIsLoading] = useState(true)

  const updateMarketPrices = useCallback(() => {
    setMarkets(prevMarkets =>
      prevMarkets.map(market => {
        const newPrice = generatePriceUpdate(market.price, 0.001)
        const priceChange = newPrice - market.price
        const percentChange = (priceChange / market.price) * 100
        
        // Update sparkline data
        const newSparkline = [...market.sparklineData.slice(1), newPrice]
        
        return {
          ...market,
          price: newPrice,
          change24h: parseFloat((market.change24h + percentChange).toFixed(2)),
          sparklineData: newSparkline
        }
      })
    )
  }, [])

  useEffect(() => {
    // Simulate initial loading
    const loadingTimer = setTimeout(() => {
      setIsLoading(false)
    }, 500)

    // Set up price update interval
    const updateTimer = setInterval(updateMarketPrices, updateInterval)

    return () => {
      clearTimeout(loadingTimer)
      clearInterval(updateTimer)
    }
  }, [updateInterval, updateMarketPrices])

  return { markets, isLoading, updateMarketPrices }
}
